// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sFcr","label":"styles_label__14GPb"};